(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/make-payment.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/make-payment.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  dialogs,
  account_services: accountServices,
  communication,
  initPay
} = svs.tur.pay;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const {
  getLocalizedWeekday
} = svs.utils.date;
const PRICE_PER_WEEK = 40;
const {
  playNextDrawDialog,
  apiErrors,
  fetchDrawData,
  getCloseTimeDescription
} = svs.tur.pay_lyckoplatsen;
const {
  logger
} = svs.tur.pay_lyckoplatsen;
const jupiter = svs.core.jupiter;
let wager;
function createWagerObject(_ref) {
  let {
    primaryDraw,
    secondaryDraw,
    numberOfWeeks,
    pinLocation,
    pinLocationType,
    lyckoplatsenName,
    locationName,
    charityId,
    isProlongination
  } = _ref;
  const price = PRICE_PER_WEEK * numberOfWeeks;
  const {
    lng,
    lat
  } = pinLocation;
  const geoBoardData = {
    boardProps: [],
    geoLoc: {
      latitude: lat === null || lat === void 0 ? void 0 : lat.toString().replace('.', ','),
      longitude: lng === null || lng === void 0 ? void 0 : lng.toString().replace('.', ',')
    },
    geoLocType: pinLocationType,
    geoLocName: lyckoplatsenName,
    charityId: charityId || 0
  };
  if (svs.core.detect.feature('ft-lyckoplatsen-geolocname')) {
    if (lyckoplatsenName === svs.tur.lyckoplatsen.utils.getDefaultLocationName() && locationName) {
      geoBoardData.geoLocName = locationName;
    }
  }
  const currentDrawPrimary = primaryDraw.drawNumber;
  const currentDrawSecondary = secondaryDraw.drawNumber;
  const wagers = {
    bets: [{
      productId: 'GEO1',
      drawNum: currentDrawPrimary,
      numDraws: numberOfWeeks,
      betAmountSalesGroup1: svs.utils.format.Currency(price, true),
      betAmountSalesGroup2: '0,00',
      betProperties: [],
      rowPriceMulti: 1,
      geoBoardData
    }, {
      productId: 'GEO2',
      drawNum: currentDrawSecondary,
      numDraws: 0,
      betAmountSalesGroup1: '0,00',
      betAmountSalesGroup2: '0,00',
      betProperties: [],
      rowPriceMulti: 0,
      geoBoardData
    }]
  };
  if (isProlongination) {
    wagers.bets[0].betProperties.push('PROLONGATION');
    wagers.bets[1].betProperties.push('PROLONGATION');
  }
  return wagers;
}
function pay(data, onDone, onError) {
  const {
    product = 'Lyckoplatsen',
    numberOfWeeks,
    locationName,
    pinLocationType,
    lyckoplatsenName,
    isProlongination = false
  } = data;
  let wagers;
  let primaryDraw;
  let secondaryDraw;
  let accountBalance;
  let firstDraw;
  let lastDraw;
  const price = PRICE_PER_WEEK * numberOfWeeks;
  let wasRetailCampaign = false;
  if (data.prolongOriginalWager) {
    wasRetailCampaign = data.prolongOriginalWager.totalDrawCount === 1;
  }
  const calls = [{
    fn: _ref2 => {
      let {
        next
      } = _ref2;
      svs.utils.paramHandler.set({
        key: 'pay',
        value: 'true'
      });
      next();
    }
  }, {
    in: () => ({
      price,
      product
    }),
    fn: accountServices.playerSession
  }, {
    fn: accountServices.playerSuspension
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    in: () => ({
      price
    }),
    fn: accountServices.accountBalance,
    out: args => ({
      accountBalance
    } = args)
  }, {
    fn: async _ref3 => {
      let {
        next
      } = _ref3;
      const drawData = await fetchDrawData(numberOfWeeks);
      primaryDraw = drawData.primaryDraw;
      secondaryDraw = drawData.secondaryDraw;
      firstDraw = drawData.firstDraw;
      lastDraw = drawData.lastDraw;
      wagers = createWagerObject(_objectSpread(_objectSpread({}, data), {}, {
        primaryDraw,
        secondaryDraw
      }));
      next();
    }
  }, {
    fn: _ref4 => {
      let {
        next,
        cancel
      } = _ref4;
      const isNewPrimaryDraw = !primaryDraw === data.primaryDraw;
      const isNewSecondaryDraw = !secondaryDraw === data.secondaryDraw;
      const drawOpenedToday = dateFns.isToday(new Date(primaryDraw.regOpenTime)) || dateFns.isToday(new Date(secondaryDraw.regOpenTime));

      if (drawOpenedToday || isNewPrimaryDraw || isNewSecondaryDraw) {
        return playNextDrawDialog({
          next,
          cancel,
          regCloseTime: firstDraw.regCloseTime
        });
      }
      next();
    }
  }, {
    fn: _ref5 => {
      let {
        next,
        cancel
      } = _ref5;
      const title = "Vill du betala ett spel p\xE5<br/>".concat(product, " f\xF6r ").concat(price, " kr?");
      const messages = ["Spell\xE4ngd: ".concat(numberOfWeeks, " veckor, ").concat(getLocalizedWeekday(firstDraw.regCloseTime, true, true), " till ").concat(getLocalizedWeekday(lastDraw.regCloseTime, true, true), "."), "".concat(product, " g\xE5r att annullera.")];
      dialogs.confirmPayment({
        title,
        messages,
        price,
        accountBalance,
        product,
        next,
        cancel
      });
    }
  }, {
    fn: async _ref6 => {
      let {
        next,
        cancel
      } = _ref6;
      const options = {
        path: "/wager/10/wagers",
        method: 'POST',
        data: wagers
      };
      try {
        const data = await jupiter.callAsync(options);
        wager = data.response;
      } catch (error) {
        logger.error('Error posting wager', error);
        apiErrors(error);
        cancel === null || cancel === void 0 || cancel();
        onError === null || onError === void 0 || onError(error);
        return;
      }
      next();
    }
  }, {
    fn: _ref7 => {
      let {
        next
      } = _ref7;
      next();
      const options = {
        prolong: isProlongination ? '1' : '0',
        geoLocType: pinLocationType,
        geoLocName: lyckoplatsenName === svs.tur.lyckoplatsen.utils.getDefaultLocationName() ? 'CTA_spela' : 'CTA_spelaName',
        reverseGeo: pinLocationType === 'HOME' ? '' : locationName,
        activeLoc: undefined,
        rounds: numberOfWeeks
      };
      if (isProlongination) {
        options.retailCampaign = wasRetailCampaign ? 'yes' : 'no';
      }
      const item = new svs.components.analytics.transactionItem('LYCKOPLATSEN', 'Lyckoplatsen', svs.utils.format.Currency(wager.wagerAmounts.totalAmount), 1, options);
      const transaction = new svs.components.analytics.transaction(wager.wagerClientSerial, svs.utils.format.Currency(wager.wagerAmounts.totalAmount), [item], 0, 0, undefined, 'LYCKOPLATSEN');
      svs.components.analytics.trackTransaction(transaction);
    }
  }, {
    in: () => ({
      product: 'lyckoplatsen'
    }),
    fn: communication.correctionEmail
  }];
  initPay({
    calls,
    cancel: () => {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
    },
    done: () => {
      var _wager;
      const wagerId = (_wager = wager) === null || _wager === void 0 ? void 0 : _wager.wagerClientSerial;
      onDone === null || onDone === void 0 || onDone({
        wagerId
      });
    },
    error: error => {
      onError === null || onError === void 0 || onError({
        error
      });
    }
  });
}
async function addToCart(data, onDone) {
  const {
    product,
    numberOfWeeks
  } = data;
  const drawData = await fetchDrawData(numberOfWeeks);
  const primaryDraw = drawData.primaryDraw;
  data.primaryDraw = primaryDraw;
  data.secondaryDraw = drawData.secondaryDraw;
  const firstDraw = drawData.firstDraw;
  const wagers = createWagerObject(data);
  wagers.bets[0].geoBoardData.reverseGeo = data.locationName;
  wagers.bets[1].geoBoardData.reverseGeo = data.locationName;
  const price = PRICE_PER_WEEK * numberOfWeeks;
  const productProperties = {
    wagers,
    isLive: false,
    headers: {
      source: 'SvS:TB:ITS'
    },
    productFlag: product,
    productTitle: product,
    productBrand: product,
    cost: price,
    description: getCloseTimeDescription(firstDraw.regCloseTime)
  };
  const {
    generateProductItem,
    getCartInstance
  } = svs.components.selfserviceCart;
  const wagerWrapper = generateProductItem(productProperties);
  getCartInstance().actions.addItem(wagerWrapper, error => {
    if (!error) {
      onDone === null || onDone === void 0 || onDone();
    }
  });
}
function makePayment(_ref8) {
  let {
    data,
    onDone,
    onError
  } = _ref8;
  if (isSelfService) {
    addToCart(data, onDone);
  } else {
    pay(data, onDone, onError);
  }
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  makePayment,
  createWagerObject,
  PRICE_PER_WEEK
});

 })(window);